module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/watch-h5.5a996918.png";